export default (parameters) => {
  // jWeather Configuration Globals
  if (Object.prototype.hasOwnProperty.call(window.$App.globals, 'configuration')) {
    const configurationGlobals = Object.entries(window.$App.globals.configuration)
    configurationGlobals.forEach((global) => (jweather[global[0]] = global[1]))
  }

  // jWeather Param Ids
  if (
    Object.prototype.hasOwnProperty.call(window.$App.globals, 'products') &&
    Object.prototype.hasOwnProperty.call(window.$App.globals.products, 'parameterIds')
  ) {
    const paramIds = Object.entries(window.$App.globals.products.parameterIds)
    paramIds.forEach((paramId) => (jweather[paramId[0]] = paramId[1]))
  }

  // jWeather User Settings
  if (Object.prototype.hasOwnProperty.call(window.$App.globals, 'user')) {
    jweather.user = {}
    const userSettings = Object.entries(window.$App.globals.user)
    userSettings.forEach((setting) => (jweather.user[setting[0]] = setting[1]))
  }

  // jWeather General Settings
  if (Object.prototype.hasOwnProperty.call(window.$App.globals, 'settings')) {
    // Guard: `jweather` and its `GeneralSettings` constructor come from the legacy
    // host bundle, which may not be loaded/initialized (or present at all) when this
    // runs. Without this, an unready legacy layer throws and aborts globals setup.
    if (typeof jweather !== 'undefined' && typeof jweather.GeneralSettings === 'function') {
      jweather.settings = new jweather.GeneralSettings(window.$App.globals.user.settings)
    }
  }

  // jWeather Regional Products
  if (
    Object.prototype.hasOwnProperty.call(window.$App.globals, 'products') &&
    Object.prototype.hasOwnProperty.call(window.$App.globals.products, 'mapProductIds') &&
    Object.prototype.hasOwnProperty.call(
      window.$App.globals.products,
      'defaultMapProductSettings'
    ) &&
    Object.prototype.hasOwnProperty.call(window.$App.globals.products, 'allowedMapProducts')
  ) {
    jweather.RegionalProducts = {}
    const jweatherProductIds = Object.entries(window.$App.globals.products.mapProductIds)
    jweather.RegionalProducts.DEFAULT_PRODUCTS = jweatherProductIds.forEach(
      (productId) => (jweather.RegionalProducts[productId[0]] = productId[1])
    )
    jweather.RegionalProducts.DEFAULT_PRODUCT_SETTINGS =
      window.$App.globals.products.defaultMapProductSettings
    jweather.RegionalProducts.ALLOWED_PRODUCTS =
      window.$App.globals.products.allowedMapProducts.map(
        (product) => jweather.RegionalProducts[product]
      )
  }

  // jWeather Spot Record Details
  if (
    Object.prototype.hasOwnProperty.call(window.$App.globals, 'spot') &&
    Object.prototype.hasOwnProperty.call(window.$App.globals.spot, 'spotRecordDetail')
  ) {
    const spotRecordDetails = Object.entries(window.$App.globals.spot.spotRecordDetail)
    spotRecordDetails.forEach(
      (spotRecordDetail) =>
        (jweather.Data.SpotRecordDetail[spotRecordDetail[0]] = spotRecordDetail[1])
    )
  }

  // jWeather Allowed Stations Capabilities
  if (
    Object.prototype.hasOwnProperty.call(window.$App.globals, 'spot') &&
    Object.prototype.hasOwnProperty.call(window.$App.globals.spot, 'allowedStationCapabilities')
  ) {
    const allowedStationCapabilities = Object.entries(
      window.$App.globals.spot.allowedStationCapabilities
    )
    allowedStationCapabilities.forEach((capability) => (jweather[capability[0]] = capability[1]))
  }

  // jWeather Ads
  if (Object.prototype.hasOwnProperty.call(window.$App.globals, 'ads')) {
    jweather.Ads = {}
    const jweatherAdConfiguration = Object.entries(window.$App.globals.ads)
    jweatherAdConfiguration.forEach(
      (configuration) => (jweather.Ads[configuration[0]] = configuration[1])
    )
  }
}